import type { UserInfo, RoleConfig, AuditLog } from '@trace/shared/types';
import { mockUsers } from './user';

export const mockSystemUsers: UserInfo[] = [
  mockUsers.admin!.user,
  mockUsers.manager!.user,
  mockUsers.oem!.user,
  {
    id: 'usr_04',
    username: 'inspector_wang',
    realName: '王丽娟 (质检主管)',
    role: 'manager',
    roleName: '生产厂长 (质检专员)',
    avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100&auto=format&fit=crop&q=80',
    email: 'wanglj@northrice.com',
    phone: '13800138004',
    tenantId: 'tenant_bm_001',
    tenantName: '黑龙江北米农业科技有限公司',
    permissions: ['processing:quality', 'dashboard:view'],
    status: 'active',
    createdAt: '2026-03-01T00:00:00Z',
    updatedAt: '2026-08-20T00:00:00Z',
  },
];

export const mockRoles: RoleConfig[] = [
  {
    role: 'admin',
    roleName: '集团管理人员 (系统管理员)',
    description: '拥有系统所有模块全部读取、写入、审核、导出与系统配置权限',
    defaultPath: '/dashboard',
    isSystem: true,
    dataScope: 'all',
    allowedMenus: [
      'dashboard',
      'land',
      'land:bases',
      'land:list',
      'land:varieties',
      'land:map',
      'land:certificates',
      'land:ledgers',
      'farming',
      'farming:records',
      'farming:pesticides',
      'farming:harvests',
      'farming:videos',
      'processing',
      'processing:orders',
      'processing:production-tasks',
      'processing:processing-tasks',
      'tracecode',
      'tracecode:stats',
      'tracecode:enterprises',
      'tracecode:products',
      'tracecode:generate',
      'tracecode:packages',
      'system',
      'system:users',
      'system:roles',
      'system:logs',
      'system:notarizations',
    ],
  },
  {
    role: 'manager',
    roleName: '生产厂长 (基地主管)',
    description: '聚焦自有有机基地地块划分、种植农事录入、用药登记与视频监控',
    defaultPath: '/land/list',
    isSystem: true,
    dataScope: 'tenant',
    allowedMenus: [
      'dashboard',
      'land',
      'land:bases',
      'land:list',
      'land:varieties',
      'land:map',
      'land:certificates',
      'land:ledgers',
      'farming',
      'farming:records',
      'farming:pesticides',
      'farming:harvests',
      'farming:videos',
      'tracecode:stats',
      'tracecode:generate',
      'tracecode:packages',
    ],
  },
  {
    role: 'oem',
    roleName: 'OEM 代工厂商',
    description: '聚焦代工规格档案、胚芽米加工批次创建、质检及赋码下载',
    defaultPath: '/processing/orders',
    isSystem: true,
    dataScope: 'tenant',
    allowedMenus: [
      'dashboard',
      'processing',
      'processing:orders',
      'processing:production-tasks',
      'processing:processing-tasks',
      'tracecode',
      'tracecode:stats',
      'tracecode:generate',
      'tracecode:packages',
    ],
  },
];

export const mockAuditLogs: AuditLog[] = [
  {
    id: 'log_01',
    operator: '赵国栋 (管理员)',
    role: 'admin',
    module: '溯源码管理',
    action: '批量生成 2,640 枚一物一码 (批次: PROC-20260822-001)',
    ip: '192.168.1.100',
    status: 'success',
    createdAt: '2026-08-26T16:30:00Z',
    updatedAt: '2026-08-26T16:30:00Z',
  },
  {
    id: 'log_02',
    operator: '李春山 (生产厂长)',
    role: 'manager',
    module: '种植农事追溯',
    action: '录入【秋季收割】农事台账与亩产斤数 (960斤/亩)',
    ip: '192.168.1.105',
    status: 'success',
    createdAt: '2026-08-26T15:20:00Z',
    updatedAt: '2026-08-26T15:20:00Z',
  },
  {
    id: 'log_03',
    operator: '孙海峰 (代工负责人)',
    role: 'oem',
    module: '加工代工管理',
    action: '创建胚芽米加工批次【PROC-20260825-002】',
    ip: '192.168.2.55',
    status: 'success',
    createdAt: '2026-08-26T14:10:00Z',
    updatedAt: '2026-08-26T14:10:00Z',
  },
];
